// @ts-nocheck
import React from "react";
import { Field } from "src/components/Forms/Field";
import { FormikSelect } from "src/components/Forms/Select";
import { genders } from "src/constants/influencer";

interface Props {}

const Gender: React.FC<Props> = () => {
  return (
    <Field label="Gender:" mb={26}>
      <FormikSelect
        name="gender"
        size="middle"
        placeholder="Select..."
        data={genders}
        local
        borderRadius={3}
        borderColor="grey8"
      />
    </Field>
  );
};

export default Gender;
